import React, { useEffect, useRef, useState } from 'react';
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const galleryImageContext = require.context(
  '../images/gallery/display',
  false,
  /^\.\/g\d+\.webp$/i
);

const thumbnailContext = require.context(
  '../images/gallery/thumbnails',
  false,
  /^\.\/t\d+\.webp$/i
);

const getImageNumber = (path) => Number(path.match(/\d+/)?.[0] ?? 0);
const resolveAsset = (asset) => asset.default ?? asset;
const PRELOAD_DISTANCE = 2;

const thumbnailsByNumber = new Map(
  thumbnailContext.keys().map((path) => [
    getImageNumber(path),
    resolveAsset(thumbnailContext(path)),
  ])
);

const images = galleryImageContext.keys()
  .sort((a, b) => getImageNumber(a) - getImageNumber(b))
  .map((path) => {
    const original = resolveAsset(galleryImageContext(path));
    const thumbnail = thumbnailsByNumber.get(getImageNumber(path)) ?? original;

    return {
      original,
      thumbnail,
      loading: 'lazy',
      thumbnailLoading: 'lazy',
      originalAlt: `웨딩 사진 ${getImageNumber(path)}`,
      thumbnailAlt: `웨딩 사진 ${getImageNumber(path)} 썸네일`,
    };
  });

function ImgGallery() {
  const galleryRef = useRef(null);
  const preloadedImagesRef = useRef(new Set());
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const gallery = galleryRef.current;

    if (gallery?.handleTouchMove) {
      // react-image-gallery@1.3.0 registers this non-passive listener on
      // window and prevents the page from scrolling after a horizontal
      // gesture is detected. The gallery's own swipe handlers still work
      // without this global scroll-blocking listener.
      window.removeEventListener('touchmove', gallery.handleTouchMove);
    }
  }, []);

  useEffect(() => {
    if (navigator.connection?.saveData || images.length < 2) {
      return;
    }

    for (let offset = -PRELOAD_DISTANCE; offset <= PRELOAD_DISTANCE; offset += 1) {
      if (offset === 0) {
        continue;
      }

      const imageIndex = (currentIndex + offset + images.length) % images.length;
      const source = images[imageIndex].original;

      if (preloadedImagesRef.current.has(source)) {
        continue;
      }

      const preloadImage = new Image();
      preloadImage.decoding = 'async';
      preloadImage.src = source;
      preloadedImagesRef.current.add(source);
    }
  }, [currentIndex]);

  return (
    <div className='bc-alt container'>
      <ImageGallery
        ref={galleryRef}
        items={images}
        lazyLoad
        onSlide={setCurrentIndex}
      />
    </div>
  )
}

export default ImgGallery
